import { createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../utils/request';
import { METHOD_POST } from '../../constants/api';

const getCarYearList = createAsyncThunk(
  'general/getCarYearList',
  async (formData = {}, { rejectWithValue }) => {
    try {
      return await authSet(METHOD_POST, '/general/list/carYear', formData);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export default getCarYearList;
